declare global {
  interface Window {
    turnstile?: {
      render: (
        element: HTMLElement,
        options: {
          sitekey: string;
          action: string;
          execution: "execute";
          callback: (token: string) => void;
          "error-callback": () => void;
          "expired-callback": () => void;
        }
      ) => string;
      execute: (widgetId: string) => void;
      reset: (widgetId: string) => void;
    };
  }
}

let scriptPromise: Promise<void> | null = null;

function loadTurnstileScript(): Promise<void> {
  if (window.turnstile) return Promise.resolve();
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>('script[src*="challenges.cloudflare.com/turnstile"]');
    if (existing) {
      existing.addEventListener("load", () => resolve(), { once: true });
      existing.addEventListener("error", () => reject(new Error("Turnstile failed to load")), { once: true });
      return;
    }
    const script = document.createElement("script");
    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
    script.async = true;
    script.defer = true;
    script.addEventListener("load", () => resolve(), { once: true });
    script.addEventListener("error", () => reject(new Error("Turnstile failed to load")), { once: true });
    document.head.appendChild(script);
  });
  return scriptPromise;
}

export async function executeTurnstile(siteKey: string | undefined, container: HTMLElement | null): Promise<string> {
  if (!siteKey || siteKey === "dev") {
    const isLocal =
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1" ||
      window.location.hostname === "";
    if (isLocal) return "dev-turnstile-token";
    throw new Error("Turnstile is not configured");
  }
  if (!container) throw new Error("Turnstile is not ready");
  await loadTurnstileScript();
  if (!window.turnstile) throw new Error("Turnstile is not available");

  return new Promise((resolve, reject) => {
    let settled = false;
    const widgetId = window.turnstile!.render(container, {
      sitekey: siteKey,
      action: "unc_check",
      execution: "execute",
      callback: (token) => {
        if (settled) return;
        settled = true;
        window.turnstile?.reset(widgetId);
        resolve(token);
      },
      "error-callback": () => {
        if (settled) return;
        settled = true;
        reject(new Error("Turnstile failed"));
      },
      "expired-callback": () => {
        if (settled) return;
        settled = true;
        reject(new Error("Turnstile expired"));
      }
    });
    window.turnstile!.execute(widgetId);
  });
}
